const video = document.querySelector(".video-container video")

function currentTime(videoTime) {
  // Check if videoTime is a valid number
  if (isNaN(videoTime) || videoTime === undefined || videoTime === null) {
    return "0:00"
  }

  const minutes = Math.floor(videoTime / 60)
  const seconds = Math.floor(videoTime - minutes * 60)

  return `${minutes}:${seconds < 10 ? "0" + seconds : seconds}`
}

function videoControls() {
  const videoContainer = document.querySelector(".video-container")
  const playerPlayPause = document.querySelectorAll(".play-pause")
  const playerProgress = document.querySelector(".progress")
  const fullscreen = document.querySelector(".fullscreen")
  const videoLength = document.querySelector(".video-length")
  const videoCurrentTime = document.querySelector(".video-current-time")

  // Initially set to 0:00 until video metadata is loaded
  videoCurrentTime.textContent = "0:00"
  videoLength.textContent = "0:00"

  /**
   * Play / Pause
   */
  playerPlayPause.forEach(function (button) {
    button.addEventListener("click", function () {
      if (video.paused || video.ended) {
        video.play()
        playerPlayPause.forEach((btn) => btn.classList.add("is-paused"))

        videoContainer.classList.remove("is-playing")
      } else {
        video.pause()
        playerPlayPause.forEach((btn) => btn.classList.remove("is-paused"))
        videoContainer.classList.add("is-playing")
      }
    })
  })

  /**
   * Progress
   */
  video.addEventListener("loadedmetadata", function () {
    playerProgress.setAttribute("max", video.duration)

    // Set initial times only after metadata is loaded
    videoCurrentTime.textContent = currentTime(video.currentTime)
    videoLength.textContent = currentTime(video.duration)
  })

  video.addEventListener("timeupdate", function () {
    if (!playerProgress.getAttribute("max")) {
      playerProgress.setAttribute("max", video.duration)
    } else {
      playerProgress.value = video.currentTime
      videoCurrentTime.textContent = currentTime(video.currentTime)
    }
  })

  // Skip ahead
  playerProgress.addEventListener("click", function (e) {
    var rect = this.getBoundingClientRect()
    var pos = (e.pageX - rect.left) / this.offsetWidth
    video.currentTime = pos * video.duration
  })

  /**
   * Fullscreen
   */
  fullscreen.addEventListener("click", function () {
    if (video.requestFullscreen) {
      video.requestFullscreen()
    } else if (video.mozRequestFullScreen) {
      video.mozRequestFullScreen() // Firefox
    } else if (video.webkitRequestFullscreen) {
      video.webkitRequestFullscreen() // Chrome, Safari and Opera
    } else if (video.msRequestFullscreen) {
      video.msRequestFullscreen() // IE/Edge
    }
  })
}

if (video) {
  videoControls()
}
